export var Backend = {
    Decap: 'decap',
    Drupal: 'drupal'
};
export var BlockTeaserListLayout = {
    Carousel: 'CAROUSEL',
    Grid: 'GRID'
};
export var CtaIconPosition = {
    After: 'AFTER',
    Before: 'BEFORE'
};
export var CtaIconType = {
    Arrow: 'ARROW',
    None: 'NONE'
};
export var ImagePosition = {
    Left: 'left',
    Right: 'right'
};
export var InfoGridIcon = {
    Email: 'EMAIL',
    LifeRing: 'LIFE_RING',
    None: 'NONE',
    Phone: 'PHONE'
};
export var Locale = {
    De: 'de',
    En: 'en'
};
export var CreateSubmissionMutation = "CreateSubmissionMutation:b585180e5579cb960b45197ad15ac71e5dc70d92bc935df5e2c92574edcd8d37";
export var ContentHubQuery = "ContentHubQuery:b9e2b7105b9ca7f372a9f3979165cbf818ea7e249504a0856c4f00936b559366";
export var ContentHubTermsQuery = "ContentHubTermsQuery:4c8c7f5b6bc53d9638289cc9d4e60e55ba51534e8ec81a6c8903604e7a27416e";
export var FrameQuery = "FrameQuery:0947676cc7f3b3a8580100f8e3321d4796c6e4fc744ed6becc287c6d6c26f763";
export var HomePageQuery = "HomePageQuery:a33fd631794731c286c94ae1471fe5d4ea2d990c38ca6056c41418e52022877a";
export var ListPagesQuery = "ListPagesQuery:1f7e06f1abff052f072012075876848f4df447641e84c1cb9ab5809ae923108a";
export var NotFoundPageQuery = "NotFoundPageQuery:df027e2364e60ed6ef2e518d055850ed5803a1940925bd2a40ef94d87c40eaf7";
export var PreviewDecapPageQuery = "PreviewDecapPageQuery:4ed1a6b38f1f985bd04de9bbf8e6f5c6cbc61c96f3c6c4267578e05c2de0c6f3";
export var PreviewDrupalPageQuery = "PreviewDrupalPageQuery:0b3f9fbcbc4e2e73a47ea20809fcfe0f9da3fdfa2a72311234fadd6c0ecf7a02";
export var TeaserListQuery = "TeaserListQuery:5c6804cfbe9fd4d40d09cb075d94af9d5bf4625668d6aeff31e6dfc249ed4546";
export var ViewPageQuery = "ViewPageQuery:5f1333b1c3fbbec51505d1efcea47680f87ad14199672db247a0b7fbfc6593cf";
